export function isTrustedBookingCoordinate(value) {
  if (!value || typeof value !== "object" || Array.isArray(value)) return false;
  const { lat, lng } = value;
  return (
    typeof lat === "number" &&
    typeof lng === "number" &&
    Number.isFinite(lat) &&
    Number.isFinite(lng) &&
    lat >= -90 &&
    lat <= 90 &&
    lng >= -180 &&
    lng <= 180 &&
    !(lat === 0 && lng === 0)
  );
}

export function updateBookingRouteField(previous, key, value) {
  const next = { ...previous, [key]: value };
  if (key === "pickupLocation" && String(value ?? "").trim() !== String(previous.pickupLocation ?? "").trim()) {
    next.pickupCoords = null;
    next.pickupPlaceId = "";
  }
  if (key === "destination" && String(value ?? "").trim() !== String(previous.destination ?? "").trim()) {
    next.destinationCoords = null;
    next.destinationPlaceId = "";
  }
  return next;
}

export function getBookingRouteDataReadiness(booking) {
  const originConfirmed = isTrustedBookingCoordinate(booking?.pickupCoords);
  const destinationConfirmed = isTrustedBookingCoordinate(booking?.destinationCoords);
  return Object.freeze({
    ready: originConfirmed && destinationConfirmed,
    originConfirmed,
    destinationConfirmed,
  });
}
